import React from 'react';
import { FlaskConical } from 'lucide-react';

interface DemoLoginButtonProps {
  onDemoLogin: (email: string) => void;
}

const DemoLoginButton: React.FC<DemoLoginButtonProps> = ({ onDemoLogin }) => {
  const isDemoEnabled = import.meta.env.VITE_ENABLE_DEMO_ACCT === 'true';
  const demoEmail = import.meta.env.VITE_DEMO_EMAIL || 'demo@pixel-share.com';

  if (!isDemoEnabled) return null;

  return (
    <div className="mt-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-amber-200" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-amber-50 text-amber-600 font-medium rounded">
            Demo Access
          </span>
        </div>
      </div>

      <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-4">
        <div className="flex items-center mb-2 text-amber-700">
          <FlaskConical size={16} className="mr-2 shrink-0" />
          <h3 className="text-sm font-semibold">Try the Demo</h3>
        </div>
        <p className="text-xs text-amber-600 mb-3">
          Explore Pixel Share with a pre-loaded demo account. No real data will be affected.
        </p>
        <button
          type="button"
          onClick={() => onDemoLogin(demoEmail)}
          className={[
            'w-full rounded-md px-4 py-2 text-sm font-medium',
            'bg-amber-400 text-amber-900 hover:bg-amber-500',
            'focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-1',
            'transition-colors duration-150',
          ].join(' ')}
        >
          Send Demo Magic Link
        </button>
      </div>
    </div>
  );
};

export default DemoLoginButton;
